import { render, staticRenderFns } from "./LocalizacionMama.vue?vue&type=template&id=dd932a86&scoped=true"
import script from "./LocalizacionMama.vue?vue&type=script&lang=js"
export * from "./LocalizacionMama.vue?vue&type=script&lang=js"
import style0 from "./LocalizacionMama.vue?vue&type=style&index=0&id=dd932a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd932a86",
  null
  
)

export default component.exports